import type { CustomerInfo } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { mergeLeft } from 'merge-left-utils'

export interface CustomerFormState {
  id?: GQL_ID
  status?: number
  phone: string
  first_name?: string
  last_name?: string
  receipt_email?: string
}

export const CUSTOMER_DEFAULT_STATE: CustomerFormState = {
  id: undefined,
  status: 0,
  phone: '',
  first_name: '',
  last_name: '',
  receipt_email: ''
}

export const makeCustomerFormState = (
  customerInfo?: CustomerInfo
): CustomerFormState => {
  return mergeLeft<CustomerFormState>(CUSTOMER_DEFAULT_STATE, customerInfo)
}

export const mapStateToApiVariable = (state: CustomerFormState): any => ({
  id: state.id,
  status: Number(state.status),
  phone: state.phone,
  first_name: state.first_name,
  last_name: state.last_name,
  receipt_email: state.receipt_email
})

export const mapApiDataToState = (data: CustomerInfo): CustomerFormState => ({
  id: data.id,
  status: Number(data.status),
  phone: data.phone,
  first_name: data.first_name,
  last_name: data.last_name,
  receipt_email: data.receipt_email
})
